
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Index from "./pages/Index";
import LoginPage from "./pages/auth/Login";
import CallbackPage from "./pages/auth/Callback";
import Dashboard from "./pages/Dashboard";
import Updates from "./pages/Updates";
import SharedFloorPlans from "./pages/SharedFloorPlans";
import Profile from "./pages/Profile";
import Settings from "./pages/Settings";
import NoAccess from "./pages/NoAccess";
import AdminDashboard from "./pages/admin/Dashboard";
import AdminSettings from "./pages/admin/Settings";
import AdminLogin from "./pages/admin/Login";
import NotFound from "./pages/NotFound";
import { Toaster } from "@/components/ui/toaster";
import AdminLayout from "./components/layouts/AdminLayout";
import RequireAdmin from "./components/auth/RequireAdmin";
import RequireTPUser from "./components/auth/RequireTPUser";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<RequireTPUser><Index /></RequireTPUser>} />
        
        {/* Beschermde routes - alleen toegankelijk voor TP users */}
        <Route path="/dashboard" element={<RequireTPUser><Dashboard /></RequireTPUser>} />
        <Route path="/shared" element={<RequireTPUser><SharedFloorPlans /></RequireTPUser>} />
        <Route path="/updates" element={<RequireTPUser><Updates /></RequireTPUser>} />
        <Route path="/profile" element={<RequireTPUser><Profile /></RequireTPUser>} />
        <Route path="/instellingen" element={<RequireTPUser><Settings /></RequireTPUser>} />
        
        <Route path="/geentoegang" element={<NoAccess />} />
        <Route path="/auth/login" element={<LoginPage />} />
        <Route path="/auth/callback" element={<CallbackPage />} />
        
        {/* Admin routes */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<RequireAdmin><AdminLayout /></RequireAdmin>}>
          <Route index element={<Navigate to="/admin/dashboard" replace />} />
          <Route path="dashboard" element={<AdminDashboard />} />
          <Route path="settings" element={<AdminSettings />} />
        </Route>
        
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Toaster />
    </Router>
  );
}

export default App;
